import { cva } from 'class-variance-authority'

export const labelStyles = cva(
  `
    flex
    flex-col
    justify-center
    gap-2
    rounded-lg
    focus:bg-neutral-100
    focus:text-neutral-400
  `,
  {
    variants: {
      error: {
        true: `
          focus-visible:ring-0
          placeholder:text-neutral-400
          placeholder:body-sm
          border-2
          border-danger-50
        `,
      },
      disabled: {
        true: `
          cursor-not-allowed
        `,
      },
    },
    defaultVariants: {
      error: false,
      disabled: false,
    },
  }
)

export const textStyles = cva(
  `
    text-neutral-400
    truncate
    min-w-0
  `,
  {
    variants: {
      error: {
        true: `
          focus-visible:ring-0
          placeholder:text-neutral-400
          placeholder:body-sm
          border-2
          border-danger-50
        `,
      },
      isFileUploaded: {
        true: `
          text-neutral-900
        `,
      },
    },
    defaultVariants: {
      error: false,
      isFileUploaded: false,
    },
  }
)
